export default {
	GET_USER(state) {
		try {
			state.user = JSON.parse(localStorage.getItem('USER'))
		} catch (error) {}
	},
	SET_USER(state, user) {
		state.user = user
		if (user) {
			localStorage.setItem('USER', JSON.stringify(user))
		} else {
			localStorage.removeItem('USER')
		}
	}
}